import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../shared/packages/searchParamsManager';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import { toInteger } from '../../../../shared/packages/searchParamsNormalizer';

const key = searchParamKeys.roomsTablePage;

export const usePageConfig = () => {
  const value = useSearchParamsSelector((state) => toInteger(state[key])) ?? 1;

  const { setParams } = useSearchParamsMethods();

  const onChange = (value) => {
    setParams({ [key]: value });
  };

  return { value, onChange };
};
